import { connect, mapProps } from '@formily/react';
import { CnRadioGroup as UiCnRadioGroup, } from '@/components/cn-radio';
import { mapSize } from '@/form/__builtins__';
export const CnRadioGroup = connect(UiCnRadioGroup, mapProps({
    dataSource: true,
}, mapSize));
